<template>
  <div class="paymentCenter w w1200">
    <el-breadcrumb
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }"><i></i>首页</el-breadcrumb-item>
      <el-breadcrumb-item>支付中心</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="20">
      <el-col :span="6">
        <div class="paymentCenter_left">
          <div class="xunyouImg">
            <el-image class="xunyouText" :src="userInfo.avatar">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <p>{{ userInfo.userName }}</p>
          </div>
          <div class="xunyouImg">
            <p class="clickmoney" @click="toMyCard('2')">
              <i class="el-icon-money"></i>储值宝:
              <i>¥ {{ getUserPay.userMoney | decimal }}</i>
            </p>
            <p>
              <i class="el-icon-bank-card"></i> 积分:
              <i>¥ {{ getUserPay.userPoints | decimal }}</i>
            </p>
          </div>
          <div class="xunyouImg money">
            <p class="sets" @click="bindPhoneHandle">
              <i class="el-icon-setting"></i> 设置支付密码
            </p>
          </div>
        </div>
      </el-col>
      <el-col :span="18">
        <div class="paymentCenter_right">
          <el-tabs
            v-model="activeName"
            @tab-click="tabhandleClick"
            v-loading="loading">
            <el-tab-pane name="2">
              <span slot="label"><i class="el-icon-money"></i> 储值宝账户<span
                class="badge-red">¥{{ getUserPay.userMoney | decimal }}</span></span>
              <div class="tab_pane_content">
                <el-row class="moneyNum">
                  <el-col :span="12">
                    <div class="balance">
                      <div>
                        <i class="el-icon-bank-card"></i>
                      </div>
                      <div class="balanceNum">
                        <p>
                          ¥
                          <countTo :startVal="startVal" :endVal="getUserPay.userMoney"
                                   :separator="','" :decimals="2" :duration="3000" :autoplay="true"></countTo>
                        </p>
                        <span>储值宝可用余额</span>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="freezeBalance">
                      <div>
                        <i class="el-icon-bank-card"></i>
                      </div>
                      <div class="balanceNum">
                        <p>
                          ¥<countTo
                            :startVal="startValFree"
                            :endVal="getUserPay.userMoneyFrozen"
                            :separator="','"
                            :decimals="2"
                            :duration="3000"
                            :autoplay="true"></countTo>
                        </p>
                        <span>储值宝冻结余额</span>
                      </div>
                    </div>
                  </el-col>
                </el-row>
                <div class="tab_pane_content">
                  <el-table :data="tableData" border>
                    <el-table-column prop="amount" label="金额(元)">
                      <template slot-scope="scope">{{scope.row.statusType === 1 ? '+' : '-'}}{{scope.row.amount}}</template>
                    </el-table-column>
                    <el-table-column prop="type" label="交易类型">
                      <template slot-scope="scope">
                        <span>{{ orderTypeMaps[scope.row.type] }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="时间">
                    </el-table-column>
                    <el-table-column prop="remark" label="备注">
                    </el-table-column>
                    <el-table-column prop="remark" label="操作">
                      <template slot-scope="scope">
                        <el-link type="primary" @click="showDetail(scope.row)">明细</el-link>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <!-- 分页组件 -->
                <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane name="7" v-if="isMerchant">
              <span slot="label"><i class="el-icon-wallet"></i> 商户账户</span>
              <div class="tab_pane_content">
                <merchant-account @showPassword="bindPhoneHandle"></merchant-account>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
    </el-row>

    <!-- 设置支付密码 开始 -->
    <el-dialog
      :visible.sync="bindPhoneboxdialog"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :before-close="handleClose"
      width="40%"
      title="设置支付密码"
      center>
      <el-form :model="payForm" status-icon :rules="rules" ref="payForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="手机号码" prop="phone">
          <el-input v-model="payForm.phone" placeholder="请输入手机号" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item prop="smsCode" label="短信验证">
          <el-input placeholder="请输入验证码" maxlength="6" v-model="payForm.smsCode">
            <template slot="append">
              <button type="button" class="btn-sms" :disabled="totalTime !== 60" @click="sendSmsCode">{{ totalTime === 60 ? '发送验证码' : `${totalTime}s后重发` }}</button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="支付密码" prop="newPass">
          <el-input placeholder="请输入新密码" type="password" v-model="payForm.newPass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input placeholder="请确认密码" type="password" v-model="payForm.checkPass" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span class="dialog-footer" slot="footer">
        <el-button @click="hideDialog">取 消</el-button>
        <el-button type="primary" @click="submitPayPassword">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 设置支付密码 结束 -->
    <yh-flow-detail ref="detail"></yh-flow-detail>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import {sendSms, editPayPassword, payList,getUserPay,
  recharge_card_turnover,balanceTurnover} from '../../api/xunyou'
import {getRandomCode, dateFormat} from "@/api/order"
import countTo from "vue-count-to";
import SIdentify from '@/components/sidentify';
import MerchantAccount from './merchantAccount';
import YhFlowDetail from './yhFlowDetail';

export default {
  name: 'paymentCenter',
  data() {
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.payForm.newPass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      totalTime: 60,
      timer: null,
      orderTypeMaps: {
        1: '充值',
        2: '购物',
        3: '提现',
        4: '销售',
        5: '退货付款',
        6: '退货收款',
        7: '其他',
        8: '佣金',
        9: '后台改价',
        10: '冲正'
      },
      // 左侧用户金额
      getUserPay: {},
      // 设置支付密码
      bindPhoneboxdialog: false,
      step: 1,
      payForm: {
        phone: this.$store.state.userInfo.phonenumber || '',
        bizId: '',
        smsCode: '',
        newPass: '',
        checkPass: ''
      },
      count: '',
      // 数字初始值
      startVal: 0,
      startValFree: 0,
      // isMycard:this.$route.query.isMycard||0, // 是否是从我的充值卡跳过来的
      isShow: false,
      rechargeVdialogVisible: false,
      rechargeNum: 1000,
      payMethods: "1", // 充值方式
      loading: false,
      userInfo: this.$store.state.userInfo,
      activeName: "2",
      currentPage: 1,
      payListArr: [],
      tableData: [],
      orderMsg: [],
      // 我的充值卡查询
      myCardData: [],
      // 分页参数
      pageparm: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 请求数据参数
      formInline: {
        pageSize: 10,
        pageNum: 1,
        uid: this.$store.state.userInfo.userId,
      },

      formLabelAlign: {
        trans_amount: "", //订单总金额
        identity: "", // 收款账号
      },
      rules: {
        trans_amount: [{required: true, message: "请输入", trigger: "blur"}],
        identity: [{required: true, message: "请输入", trigger: "change"}],
        smsCode: [{required: true, message: "不能为空", trigger: ["blur"]},],
        newPass: [{required: true, pattern: /^\d{6}$/, trigger: ["blur"], message: '请输入6位纯数字支付密码'}],
        checkPass: [{required: true, trigger: ["blur"], validator: validatePass2}],
      },
    };
  },
  computed: {
    isMerchant() {
      return this.$store.getters.isMerchant;
    }
  },
  // 注册组件
  components: {Pagination, countTo, SIdentify, MerchantAccount, YhFlowDetail},
  mounted() {
    if (this.$route.fullPath.indexOf("tap") > 0) {
      this.activeName = this.$route.query.tap;
    }
    this.getUserMoney();
    this.getMyCard();
    this.getbalanceTurnover()
    this.getPayList()
    this.setOrdermsg()
  },
  methods: {
    // 显示明细
    showDetail (flow) {
      this.$refs.detail.show(flow);
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      if (this.activeName == 2) {
        this.getbalanceTurnover()
      } else if (this.activeName == 6) {
        this.getMyCard();
      } else if (this.activeName == 1) {
        this.getPayList()
      }
    },
    //支付状态
    orderStatuspay(status) {
      switch (status) {
        case 1:
          return '成功'
          break;
        case 2:
          return '失败'
          break;
      }
    },
    //交易类型
    orderStatustype(status) {
      switch (status) {
        case 1:
          return '充值'
          break;
        case 2:
          return '购物'
          break;
        case 2:
          return '佣金'
          break;
      }
    },

    //   跳到我的充值卡
    toMyCard(activeName) {
      this.activeName = activeName;
      if (this.activeName == 2 || this.activeName == 6) {
        // 重置初始值
        this.startVal--;
      }
    },

    // --------------------设置支付密码 开始-------------------------
    bindPhoneHandle() {
      this.step = 1;
      this.bindPhoneboxdialog = true
    },
    timeCountdown () {
      this.totalTime -= 1;
      if (this.totalTime <= 0) {
        clearTimeout(this.timer);
        this.totalTime = 60;
      } else {
        this.timer = setTimeout(this.timeCountdown, 1000);
      }
    },
    sendSmsCode () {
      this.timeCountdown();
      sendSms({
        TemplateCode: 'SET_PAYWD',
        phoneNumbers: this.payForm.phone
      }).then(res => {
        console.log('发送验证码：', res);
        if (res.Code === 'OK') {
          this.payForm.bizId = res.BizId;
        } else {
          this.$message.error(res.Message);
          this.totalTime = 0;
        }
      }).catch(err => {
        console.error('错误：', err);
        this.totalTime = 0;
      });
    },
    submitPayPassword() {
      this.$refs.payForm.validate(valid => {
        if (valid) {
          const params = {
            uid:this.$store.getters.userId,
            newpassword: this.payForm.newPass,
            bizId: this.payForm.bizId,
            smsCode: this.payForm.smsCode,
          }
          editPayPassword(params)
            .then((res) => {
              if (res.code === 0) {
                this.$message.success('设置成功！');
                this.hideDialog()
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              this.$message.error("校验失败，请稍后再试！");
            });
        }
      })
    },
    handleClose (done) {
      this.resetPayForm();
      done();
    },
    hideDialog () {
      this.bindPhoneboxdialog = false;
      this.resetPayForm();
    },
    // 取消
    resetPayForm() {
      this.payForm = {
        phone: this.$store.state.userInfo.phonenumber || '',
        smsCode: '',
        newPass: '',
        checkPass: '',
      }
    },
    // --------------------设置支付密码 结束-------------------------

    //   切换tab
    tabhandleClick(tab, event) {
      if (this.activeName == 5) {
        this.rechargeVdialogVisible = true;
      } else if (this.activeName == 2) {
        this.getbalanceTurnover()
        // 重置初始值
        this.startVal--;
      } else if (this.activeName == 6) {
        this.getMyCard()
        // 重置初始值
        this.startVal--;
      } else if (this.activeName == 1) {
        this.getPayList()
      }
    },

    // 查询用户的有关金额
    getUserMoney() {
      getUserPay({
        userId: this.userInfo.userId,
      }).then((res) => {
          console.log(res, "查询用户的有关金额");
          this.getUserPay = res.data;

        })
        .catch((err) => {
          this.$message.error("查询用户的有关金额失败，请稍后再试！");
        });
    },
    // //   提现
    // applyMoney(){
    //     this.isShow = !this.isShow
    // },

    /** 交易查询流水表 开始*/
    getPayList() {
      payList(this.formInline)
        .then((res) => {
          if (res.code == 0) {
            console.log(res)
            this.payListArr = res.rows
            this.pageparm.total = res.total
            // 分页赋值
            this.pageparm.currentPage = this.formInline.pageNum
            this.pageparm.pageSize = this.formInline.pageSize
          }
        })
        .catch((err) => {
          this.$message.error("余额流水查询失败，请稍后再试！");
        });
    },
    /** 交易查询流水表 结束*/

    /** 账户余额 开始*/
    // 余额流水
    getbalanceTurnover() {
      balanceTurnover(this.formInline)
        .then((res) => {
          if (res.code == 0) {
            console.log('余额流水查询', res)
            this.tableData = res.rows
            this.pageparm.total = res.total
            this.pageparm.currentPage = this.formInline.pageNum
            this.pageparm.pageSize = this.formInline.pageSize
          }
        })
        .catch((err) => {
          this.$message.error("余额流水查询失败，请稍后再试！");
        });
    },


    /** 账户余额 结束*/

    /** 我的充值卡 开始*/
    getMyCard() {
      recharge_card_turnover(this.formInline)
        .then((res) => {
          if (res.code == 0) {
            this.myCardData = res.rows;
            // 分页赋值
            this.pageparm.currentPage = this.formInline.pageNum;
            this.pageparm.pageSize = this.formInline.pageSize;
            this.pageparm.total = res.total;
          }
        })
        .catch((err) => {
          this.$message.error("查询我的充值卡失败，请稍后再试！");
        });
    },

    /** 我的充值卡 结束*/

    //   点击充值
    rechargeHandle() {
      if (this.rechargeNum == "" || this.rechargeNum == null) {
        this.$message({
          type: "info",
          message: "请填入充值金额数",
        });
        return;
      }
      this.rechargeVdialogVisible = false;
    },
    //生成模拟订单
    setOrdermsg() {
      const ordermsg = getRandomCode()
      this.orderMsg = ordermsg
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>

<style scoped lang="less">
.btn-sms{
  width: 110px;
  height: 40px;
  background-color: var(--main-theme-color);
  color: #FFFFFF;
  border: none;
  appearance: none;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  &[disabled]{
    color: #333333;
    background-color: #eeeeee;
  }
}
/deep/ .el-input-group__append{
  padding: 0;
  border: none;
}
.paymentCenter {
  margin-top: 0;
  box-sizing: border-box;

  .breakcrumbHeader {
    margin: 15px 0;
  }

  .paymentCenter_left,
  .paymentCenter_right {
    background: white;
    padding: 20px;
    box-sizing: border-box;
  }

  .paymentCenter_left {
    .xunyouImg {
      text-align: center;
      width: 100%;
      border-bottom: 1px solid #ccc;

      .xunyouText {
        border-radius: 50%;
        width: 160px;
        height: 160px;
      }

      p {
        font-size: 16px;
        margin: 20px 0;
      }

      .clickmoney {
        cursor: pointer;
      }

      .clickmoney:hover {
        color: var(--main-theme-color);
      }
    }

    .money .sets:hover {
      cursor: pointer;
      color: var(--main-theme-color);
    }
  }

  .paymentCenter_right {
    /deep/ thead.has-gutter {
      color: #333;
      text-align: center;
    }

    .pagination {
      text-align: end;
      margin-top: 20px;

      /deep/ li.number {
        width: 40px;
      }

      /deep/ input[readonly],
      input[readonly="readonly"] {
        background-color: white;
      }
    }

    .moneyNum.el-row {
      margin-bottom: 30px;

      .el-col {
        height: 100%;
      }

      height: 80px;
      background: red;

      .balance,
      .freezeBalance {
        height: 100%;
        background: #68b828;
        padding: 15px;
        display: flex;
        justify-content: flex-start;
        box-sizing: border-box;
        // margin-left: 20px;
        // font-size: 25px;
        color: white;

        i {
          font-size: 55px;
        }

        .balanceNum {
          padding: 0 20px;

          p {
            font-size: 28px;
          }
        }
      }

      .freezeBalance {
        background: #f7aa47;
      }
    }

    .payMethods_img {
      // margin: 20px;
      border: 1px solid #ccc;
      width: 180px;
    }

    .rechangNumber {
      color: #9c9c9c;
      font-size: 16px;
      margin: 15px;
    }

    // 账户余额 充值卡
    .badge-red {
      background-color: #cc3f44;
      padding: 2px 5px;
      border-radius: 15px;
      color: white;
    }

    //余额提现
    .applyMoney {
      background-color: #eee;
      border-color: #eee;
      color: #333;
      padding: 0 20px;
      margin-bottom: 20px;
    }
  }
}

.pagination {
  text-align: right;

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: var(--main-theme-color);
    color: #fff;
    width: 20px;
  }

  /deep/ .el-pagination.is-background .btn-next,
  /deep/ .el-pagination.is-background .btn-prev,
  /deep/ .el-pagination.is-background .el-pager li {
    width: 20px;
  }

  /deep/ input[disabled],
  input[disabled="disabled"],
  input[readonly],
  input[readonly="readonly"] {
    background-color: transparent;
  }
}
</style>







// WEBPACK FOOTER //
// src/views/siteNavigation/paymentCenter.vue